import { TCreateUserDTO } from '@/pages/Users/users.types.ts'

const generateCreateUserDTO = (initialData: Partial<TCreateUserDTO>): TCreateUserDTO => ({
  organizationId: null,
  position: '',
  userInfo: {
    lastName: '',
    middleName: '',
    firstName: '',
    phoneNumber: '',
  },
  email: '',
  active: true,
  password: '',
  login: '',
  roleId: 2,
  ...initialData,
})

const normalizePosition = (pos: string): string => {
  if (!pos) return ''
  const trimmed = pos.trim().toLowerCase()
  return trimmed ? trimmed[0].toUpperCase() + trimmed.slice(1) : ''
}

const randPassword = () =>
  new Array(10)
    .fill('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz')
    .map((x) =>
      (function (chars) {
        let umax = Math.pow(2, 32),
          r = new Uint32Array(1),
          max = umax - (umax % chars.length)
        do {
          crypto.getRandomValues(r)
        } while (r[0] > max)
        return chars[r[0] % chars.length]
      })(x)
    )
    .join('')

const usersUtils = { generateCreateUserDTO, randPassword, normalizePosition }
export default usersUtils
